export interface Disqualification {
  field: string;
}

export type DisqualificationAction =
  | { type: 'DISQUALIFY_USER'; payload: Disqualification }
  | { type: 'QUALIFY_USER'; payload: Disqualification };

export const disqualify = (payload: Disqualification): DisqualificationAction => ({
  type: 'DISQUALIFY_USER',
  payload
});
export const qualify = (payload: Disqualification): DisqualificationAction => ({
  type: 'QUALIFY_USER',
  payload
});
